<template>
  <div class="container store-goods-container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'

      :count="count"
      :current="page"
      >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input :maxlength='100'  class="item" clearable placeholder='请输入' v-model.trim='query.approvalCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>剂型:</label>

            <lk-select  v-model.trim='query.dosageForm' class="item" filterable clearable>
              <lk-option v-for="(item,index) in dosageArr" :key="index" :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>

          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select  v-model.trim='query.storageCondition' class="item" clearable>
              <lk-option v-for="(item,index) in storageConditionsArr" :key="index" :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem storeSelect">
            <label>商品标签:</label>
            <lk-select v-model='query.labelIdList' class="item" filterable clearable multiple>
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
           <div class="queryItem">
            <label>生产企业:</label>
            <lk-input  class="item" clearable placeholder='请输入' v-model="query.producer"></lk-input>
          </div>
          <div class="queryItem storeSelect" v-if="roleType===2">
            <label>首营供应商:</label>
            <SupplierListSelect v-model.trim="query.supplierStoreIdList" :multiple="true" ></SupplierListSelect>
          </div>
           <div class="queryItem">
            <label>商品类型:</label>
            <goodsTypeCascader class="item"  v-model='query.type' ></goodsTypeCascader>
          </div>
           <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.creatTime' :options='creatTimeOption'/>
          </div>
          <div class="queryItem">
            <label>审批通过时间:</label>
            <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.auditTime' :options='approvalTimeOption' />
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select clearable class="item" v-model.trim='query.auditStatus'>
              <lk-option v-for="(item) in aduitList" :key="item.index" :value='item.id'>{{item.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select clearable class="item" v-model.trim='query.status'>
              <lk-option v-for="(item,index) in statusList" :key="item" :value='index+1'>{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">

        <lk-button class="mr8" type='primary' v-if="handlePermission('storeGoodsAdd')" @click='addNew'>+ 新建首营商品</lk-button>
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('storeGoodsExport')" ></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal :title="isStop ? '停用商品' : '启用商品'" v-model="showReason" :footer-hide='true' width="400" :closable='false'
        :mask-closable='false'>
      <div style="display:flex;">
          <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
          <h6 style="margin-top: 7px;font-size: 12px;">是否确认{{ isStop ? '停用' : '启用'}}此商品？</h6>
      </div>
      <div style="display:flex">
        <span v-if="isStop" class="redMark">*</span>
        <span :class="isStop ? 'stopReason' : 'reason'">{{ isStop ? '停用原因：' : '停用原因：' + stopReason}}</span>
      </div>
      <lk-input v-if="isStop" class="stopInput" placeholder='请输入停用原因' :maxlength="100" clearable v-model.trim="stopReason" type="textarea"></lk-input>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="isStop ? stopReason == '' : false" @click="editGoods(editId)">确认</lk-button>
          <lk-button @click="showReason=false, getData()">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import goodsStore from '../../../services/goods';
import utils from '../../../libs/utils';
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import TreeSelect from '../../../components/treeSelect/treeSelect.vue';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins'; // 鉴权
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';
import DownloadButton from '../../../components/download/DownloadButton';
import SupplierListSelect from '../../../components/SupplierListSelect.vue';

export default {
  name: 'StoreList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    TreeSelect,
    goodsTypeCascader,
    DownloadButton,
    SupplierListSelect,
  },
  computed: {

    ...mapGetters(['getNormalGoodsTypes']),

  },
  data() {
    return {
      stopReason: '',
      editId: '',
      isStop: true,
      showReason: false,
      disablePage: false,
      labels: [],
      dosageArr: [],
      storageConditionsArr: [],
      indicationTree: [],
      curingStandardArr: ['', '一般养护', '重点养护'],
      aduitList: [{ id: 1, name: '草稿' }, { id: 2, name: '审批中' }, { id: 3, name: '审批通过' }, { id: 4, name: '审批驳回' }],
      statusList: ['启用', '禁用'],
      paymentTypeArr: [],
      drugMiniPackageUnitArr: [],
      qualityOfDrugsTypeArr: [],
      judgeArr: ['', '是', '否'],
      medicareArr: ['是', '否'], // 是否医保
      decoctionBucketArr: [],
      approvalTimeOption: this.approvalDate(),
      creatTimeOption: this.creatDate(),
      query: {
        nameMix: '',
        approvalCode: '',
        dosageForm: null,
        storageCondition: null,
        labelIdList: [],
        categoryIdList: [],
        producer: '',
        supplierStoreIdList: [],
        type: null,
        isDtp: null,
        storeIdList: [],
        creatTime: [],
        auditTime: [],
        auditStatus: '',
        status: '',
      },
      columns: [
        {
          title: '申请单号',
          key: 'goodsStoreApplyCode',
          minWidth: 168,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'goodsBaseDrugSerialCode',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '审批状态',
          key: 'approvalStatus',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '通用名/商品名称',
          key: 'goodsBaseApprovedDrugNames',
          minWidth: 142,
          tooltip: true,
        },
        { title: '商品类型', key: 'typeString', minWidth: 156 },
        {
          title: '商品名',
          key: 'goodsBaseGoodsName',
          minWidth: 142,
          tooltip: true,
        },
        {
          title: '规格', key: 'goodsBaseSpecifications', minWidth: 130, tooltip: true,
        },
        {
          title: '生产厂家', key: 'goodsBaseManufacturer', minWidth: 142, tooltip: true,
        },
        {
          title: '批准文号/注册证号', key: 'goodsBaseApprovalNumber', minWidth: 140, tooltip: true,
        },
        {
          title: '剂型',
          key: 'goodsBaseVODosageFormString',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'goodsBaseVODrugMiniPackageUnitString',
          minWidth: 62,
          tooltip: true,
        },
        {
          title: '批件号',
          key: 'drugRegApprovalCode',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '批件有效期',
          key: 'periodDrugRegApproval',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '质检标准',
          key: 'goodsBaseDrugAcceptanceStandard',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '储存条件',
          key: 'goodsBaseVOStorageConditionsString',
          minWidth: 112,
          tooltip: true,
        },
        {
          title: '供应商',
          key: 'goodsStoreSupplierStoreName',
          minWidth: 142,
          tooltip: true,
        },
        {
          title: '进项税率',
          key: 'inputTaxRate',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '销项税率',
          key: 'outputTaxRate',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '成本类型',
          key: 'paymentTypeString',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '本位码',
          key: 'goodsBaseNdcNumber',
          minWidth: 136,
          tooltip: true,
        },
        {
          title: '条形码',
          key: 'goodsBaseBarCode',
          minWidth: 102,
          tooltip: true,
        },
        {
          title: '产地',
          key: 'goodsBaseCountryOfOrigin',
          minWidth: 142,
          tooltip: true,
        },
        {
          title: '化学成分',
          key: 'goodsBaseChemicalComposition',
          minWidth: 118,
          tooltip: true,
        },
        {
          title: '是否进口',
          key: 'isImport',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '是否DTP',
          key: 'isDtp',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '是否医保',
          key: 'isMedicare',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '商品标签',
          key: 'goodsBaseVOGoodsLabelsString',
          minWidth: 142,
          tooltip: true,
        },
        {
          title: '商品分类',
          key: 'goodsBaseVOIndicationDicString',
          minWidth: 142,
          tooltip: true,
        },
        {
          title: '养护类型',
          key: 'curingStandard',
          minWidth: 82,
          tooltip: true,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '审批通过时间',
          key: 'auditPassTime',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'goodsStoreGoodsStoreStatus',
          fixed: 'right',
          minWidth: 96,
          render: (h, params) => {
            if (this.handlePermission('goodsStoreEnableDisable') && params.row.approvalStatus === '审批通过') {
              return h('lk-switch', {
                props: {
                  size: 'large',
                  value: params.row.goodsStoreGoodsStoreStatus === 1,
                  loading: params.row.loading,
                },
                on: {
                  'on-change': (e) => {
                    this.showReason = true;
                    params.row.loading = true;
                    if (e) {
                      this.isStop = false;
                      this.stopReason = params.row.disableReason;
                    } else {
                      this.stopReason = '';
                      this.isStop = true;
                    }
                    this.editId = params.row.id;
                  },
                },

              }, [
                h('span', {
                  props: {
                  },
                  slot: 'open',

                }, '启用'),
                h('span', {
                  props: {
                  },
                  slot: 'close',

                }, '禁用'),
              ]);
            }
            return h('span', params.row.goodsStoreGoodsStoreStatus === 1 ? '启用' : '禁用');
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, params) => {
            let res = null;
            let res1 = null;
            if (this.handlePermission('GoodsStoreEdit')) {
              res = (params.row.approvalStatus === '审批中' ? h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled: true,
                },
              }, '修改') : h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'GoodsStoreEdit', params: { id: params.row.goodsStoreId, type: params.row.goodsBaseType, status: params.row.status } });
                  },
                },
              }, '修改'));
            }


            res1 = (params.row.approvalStatus === '草稿' ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '是否确定删除',
                    cancelText: '取消',
                    onOk: () => {
                      this.onDelete(params.row.id);
                    },
                  });
                },
              },
            }, '删除') : null);


            return h('div', [
              this.handlePermission('GoodsStoreView') ? h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                class: 'view-btn',
                on: {
                  click: () => {
                    this.$router.push({ name: 'GoodsStoreView', params: { id: params.row.goodsStoreId, type: params.row.goodsBaseType, status: params.row.status } });
                  },
                },
              }, '查看') : null,
              res, res1,
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    Promise.all([
      this.getLabel(),
      // this.getDosageArr(),
      this.getSelectArrs(),

    ]).then(() => {
      this.handleSearch(true);
      console.log(this.params);
    });
    this.fetchListIndications();

    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店名称', key: 'goodsStoreStoreName', minWidth: 116, tooltip: true,
      });
    }
  },
  methods: {
    editGoods(id) {
      this.showReason = false;
      if (!this.isStop) {
        goodsStore.enableGoodsStoreById({ id }).then((responseData) => {
          this.stopReason = '';
          if (responseData.data.status === 200) {
            this.$Message.success('首营商品启用');
          } else {
            this.$Message.error(responseData.data.error);
          }
          this.getData();
        }).catch((err) => {
          this.getData();
          utils.handleError(err);
        });
      } else {
        goodsStore.disableGoodsStoreById({ id, disableReason: this.stopReason }).then((responseData) => {
          this.stopReason = '';
          if (responseData.data.status === 200) {
            this.$Message.success('首营商品禁用');
          } else {
            this.$Message.error(responseData.data.error);
          }
          this.getData();
        }).catch((err) => {
          this.getData();
          utils.handleError(err);
        });
      }
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.auditTime) {
        params.auditStartTime = params.auditTime[0];
        params.auditEndTime = params.auditTime[1];
        delete params.auditTime;
      }
      if (params.creatTime) {
        params.createStartTime = params.creatTime[0];
        params.createEndTime = params.creatTime[1];
        delete params.creatTime;
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      goodsStore.exportGoodsStores(params).then((res) => {
        // utils.downLoadExcel(res, '销售明细查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    walkTreeeIndications(item) {
      const res = {
        value: item.id,
        label: item.goodsIndicationDicName,
      };
      if (item.childGoodsIndicationDicVOs.length) {
        res.children = [];
        item.childGoodsIndicationDicVOs.forEach((data) => {
          res.children.push(this.walkTreeeIndications(data));
        });
      }
      return res;
    },
    fetchListIndications() {
      goodsStore.listIndications().then((res) => {
        const status = res.data.status;
        const resData = [];
        if (status === 200) {
          const data = res.data.data;
          data.forEach((item) => {
            resData.push(this.walkTreeeIndications(item));
          });
        }
        this.indicationTree = resData;
      });
    },
    addNew() {
      console.log(123);

      this.$router.push({ name: 'storeGoodsAdd' });
    },
    clear() {
      this.query = {};
    },
    approvalDate() { // 处理时间禁用问题
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.creatTime.length) {
            return time.getTime() < vm.query.creatTime[0] - 1000 * 60 * 60 * 24;
          }
        },
      };
    },
    creatDate() { // 处理时间禁用问题
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.auditTime.length) {
            return time.getTime() > vm.query.auditTime[1];
          }
        },
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.$route.params.create ? this.params.create = true : this.params.create = '';
      if (this.params.auditTime) {
        this.params.auditStartTime = this.params.auditTime[0];
        this.params.auditEndTime = this.params.auditTime[1];
        delete this.params.auditTime;
      }
      if (this.params.creatTime) {
        this.params.createStartTime = this.params.creatTime[0];
        this.params.createEndTime = this.params.creatTime[1];
        delete this.params.creatTime;
      }
      goodsStore.listGoodsStores(this.params).then((responseData) => {
        if (responseData.data.status === 200) {
          this.tableData = [];
          this.count = responseData.data.data.count;
          responseData.data.data.list.forEach((item) => {
            // console.log(item.goodsStore);
            const result = {};
            utils.exchangeTable(item, result);
            result.approvalStatus = this.aduitList.find(ele => item.goodsStore.approvalStatus === ele.id).name;
            result.status = item.goodsStore.approvalStatus;
            result.id = item.goodsStore.id;
            result.isImport = this.judgeArr[item.goodsBaseVO.goodsBase.isImport];
            result.isDtp = this.judgeArr[item.goodsStore.isDtp];
            result.curingStandard = this.curingStandardArr[item.goodsStore.curingStandard];
            result.inputTaxRate = `${item.goodsStore.inputTaxRate}%`;
            result.outputTaxRate = `${item.goodsStore.outputTaxRate}%`;
            result.createUserName = item.goodsStore.createUserName;
            result.createTime = utils.exchangeTime(item.goodsStore.createTime);
            result.auditPassTime = utils.exchangeTime(item.goodsStore.auditPassTime);
            result.loading = false;
            result.isMedicare = this.medicareArr[item.goodsStore.isMedicare - 1];
            if (item.goodsBaseVO.indicationDicString) {
              const regExp = new RegExp(',', 'g');
              result.indicationDicString = item.goodsBaseVO.indicationDicString.replace(regExp, '/');
            }
            result.drugRegApprovalCode = item.goodsBaseVO.goodsBase.drugRegApprovalCode || item.goodsBaseVO.goodsBase.importRegCertCode;
            result.buildTime = utils.exchangeTime(item.goodsStore.buildTime);
            result.periodDrugRegApproval = utils.exchangeTime(item.goodsBaseVO.goodsBase.periodDrugRegApproval || item.goodsBaseVO.goodsBase.periodImportRegCert);
            result.typeString = utils.handleGoodsTypeStr(item.goodsBaseVO.goodsBase.type);
            result.disableReason = item.goodsStore.disableReason;
            result.loading = false;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(responseData.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    getSelectArrs() {
      return new Promise((resolve) => {
        this.drugMiniPackageUnitArr = [];
        this.storageConditionsArr = [];
        this.dosageArr = [];

        goodsStore.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 1:
                  this.dosageArr.push(item);
                  break;

                case 3:
                  this.drugMiniPackageUnitArr.push(item);

                  break;
                case 9:
                  this.storageConditionsArr.push(item);

                  break;

                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getLabel() {
      goodsStore.listGoodsLabelCategories().then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          for (const key in data) {
            data[key].forEach((item) => {
              this.labels.push(item);
            });
          }
          const exsitIdArr = [];
          this.labels = this.labels.filter((item) => {
            if (exsitIdArr.includes(item.id)) {
              return false;
            }
            exsitIdArr.push(item.id);
            return true;
          });
          console.log(exsitIdArr);
          // console.log(labels);
          console.log(this.labels);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    onDelete(index) {
      const params = { id: index };
      goodsStore.deleteListData(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('删除成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },

};
</script>

<style lang="less">
.store-goods-container{
  .ivu-table-cell .ivu-btn {
    padding: 0;
  }
  .view-btn{
    margin-right: 8px;
  }
}
.bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}

  .warnIcon {
  color: orange;
  font-size: 20px;
};

.stopReason {
  margin-top:8px;
  margin-left: 4px;
  font-size: 12px;
}

.reason {
  margin-top:8px;
  font-size: 12px;
  margin-left: 23px;
}

.redMark {
  color: red;
  margin-top:6px;
  margin-left: 22px;
  font-size: 18px;
}

.stopInput{
  margin-left:22px;
  margin-right: 20px;
  width: 340px;
  margin-top: 0px;
}
</style>
